var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contracts" },
    [
      _vm.accountTypeI === _vm.ACCOUNT_TYPES.notVerified
        ? [
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-size-50 md-medium-size-65 md-small-size-95 md-xsmall-size-100 contracts__not-available-description"
              },
              [
                _c("not-available-card", {
                  attrs: {
                    icon: "work",
                    title: _vm.i18n.lbl_not_available(),
                    descr: _vm.i18n.lbl_contracts_not_available_exp()
                  }
                })
              ],
              1
            )
          ]
        : [
            !_vm.showDetails
              ? _c(
                  "md-tabs",
                  { attrs: { "md-dynamic-height": "" } },
                  [
                    _c(
                      "md-tab",
                      { attrs: { "md-label": "" + _vm.i18n.cont_signed() } },
                      [
                        _c("signed-list", {
                          on: { "open-details": _vm.openDetails }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.accountTypeI === _vm.ACCOUNT_TYPES.syndicate
                      ? _c(
                          "md-tab",
                          {
                            attrs: {
                              "md-label": "" + _vm.i18n.cont_new_contract()
                            }
                          },
                          [_c("new-contract")],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "md-tab",
                      {
                        attrs: {
                          "md-label": "" + _vm.i18n.cont_signature_requests()
                        }
                      },
                      [
                        _c("requests-list", {
                          on: { "open-details": _vm.openDetails }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "md-tab",
                      { attrs: { "md-label": "" + _vm.i18n.lbl_archive() } },
                      [
                        _c("archived-list", {
                          on: { "open-details": _vm.openDetails }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : [
                  _c("contract-details", {
                    attrs: { id: _vm.requestId, type: _vm.detailsType },
                    on: {
                      "close-details": function($event) {
                        _vm.showDetails = false
                      }
                    }
                  })
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a47da8cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a47da8cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/contracts/index/Contracts.Index.vue
// module id = fRCW
// module chunks = 1